import { memo } from 'react';
import { SummaryItem } from '../summary-item/SummaryItem';
import { Passengers } from '../../Summary.model';
interface SummaryPassengersProp {
	passengers?: Passengers;
}
import { useTranslation } from 'react-i18next';
import { PassengerItem } from '../SummaryPassenger';
import { ErrorBoundaryProvider } from '../../../../../providers/ErrorBoundaryProvider';
export const SummaryPassengers = memo(function SummaryPassengers({ passengers }: SummaryPassengersProp) {
	const { t } = useTranslation('summary');
	return (
		<ErrorBoundaryProvider>
			{passengers && (
				<SummaryItem
					title={t('PASSENGERS')}
					total={{
						title: t('HEADER_FLIGHTS_TOTAL'),
						price: passengers.total
					}}
				>
					{passengers.types.map((passenger, index) => {
						return <PassengerItem key={index} passenger={passenger} onClick={passengers.onClick}></PassengerItem>;
					})}
				</SummaryItem>
			)}
		</ErrorBoundaryProvider>
	);
});
